import { render } from "./home.vue?vue&type=template&id=572024b0&scoped=true"
const script = {}

import "./home.vue?vue&type=style&index=0&id=572024b0&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/sathikash_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572024b0"]])

export default __exports__